import * as React from "react";
import { IconPresentationProps } from "../Icon/Icon";

const Slack: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {props.title && <title>{props.title}</title>}
            <path d="M22.08 9C19.81 1.41 16.54-.35 9 1.92S-.35 7.46 1.92 15 7.46 24.35 15 22.08 24.35 16.54 22.08 9z"></path>
            <line x1="12.57" y1="5.99" x2="16.15" y2="16.39"></line>
            <line x1="7.85" y1="7.61" x2="11.43" y2="18.01"></line>
            <line x1="16.39" y1="7.85" x2="5.99" y2="11.43"></line>
            <line x1="18.01" y1="12.57" x2="7.61" y2="16.15"></line>
        </svg>
    );
};

export default React.memo(Slack);
